import { m as useOnlineStatus, dB as isApiError, av as isApiValidationError } from './className-0524835a.js';

/**
 * Returns an error message from an API response, or null if there was no error.
 *
 * @param fallback - Message to return if there is no custom message or message in the API response.
 * @param error - The API error response, or undefined if there was no error.
 * @param messages - Custom messages that override messages returned in the API response.
 * @returns An error message, or null if there was no error.
 */
function useApiErrorMessage(fallback, error, messages) {
    const { getOnlineMessage } = useOnlineStatus();
    if (!error) {
        return null;
    }
    let message = 'status' in error && (messages === null || messages === void 0 ? void 0 : messages[error.status]);
    if (!message && isApiError(error)) {
        message = error.data.message;
    }
    if (!message) {
        message = fallback;
    }
    return getOnlineMessage(message, messages === null || messages === void 0 ? void 0 : messages.offline);
}
function apiValidationErrorMessage(error, field) {
    return () => {
        var _a;
        if (isApiValidationError(error)) {
            return (_a = error.data.fieldErrors.find(error => error.field === field)) === null || _a === void 0 ? void 0 : _a.message;
        }
    };
}

export { apiValidationErrorMessage as a, useApiErrorMessage as u };
